module.exports = __webpack_public_path__ + "img/distance.0f4a1ae7.svg";